import { ArrowDropDown } from "@mui/icons-material";
import { Button, IconButton, Menu } from "@mui/material";
import React, { useState } from "react";
import LeaseAndSaleDropdownOptions from "../../../common/js/components/LeaseAndSaleDropdownOptions";
import RequestModalContainer from "../listing/RequestModalContainer";

const CreateCompModal = (props) => {
    const [showModal, setShowModal] = useState(false);
    const { internal, toggleRequestModal } = props;

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleMenuClick = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget.parentElement.parentElement);
    };

    const handleCloseDropdown = () => {
        setAnchorEl(null);
    };

    const handleShowModal = (spaceType, transactionType) => {
        setShowModal(!showModal);
        toggleRequestModal(spaceType, transactionType);
    };

    const handleOpenDropdown = (event) => {
        setAnchorEl(event.currentTarget);
    };

    return (
        <React.Fragment>
            <Button
                variant="contained"
                onClick={handleOpenDropdown}
                aria-controls={open ? "appraisal-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                endIcon={
                    <IconButton
                        onClick={handleMenuClick}
                        size="small"
                        style={{ padding: 0 }} // Remove padding for a better fit
                    >
                        <ArrowDropDown style={{ fill: "white" }} />
                    </IconButton>
                }
            >
                Create Appraisal Comp
            </Button>

            <Menu
                id="appraisal-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleCloseDropdown}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                sx={{
                    "& .MuiPaper-root": {
                        width: "20vw",
                        boxShadow: "0 6px 12px rgba(0, 0, 0, 0.175)",
                        overflowY: "auto",
                        maxHeight: "69vh",
                    },
                }}
            >
                {(open || !internal) && (
                    <div>
                        <LeaseAndSaleDropdownOptions
                            addNoListingText={internal}
                            addConsultingBlock={internal}
                            callback={(...args) => {
                                handleCloseDropdown();
                                handleShowModal(...args);
                            }}
                        />
                    </div>
                )}
            </Menu>
            <RequestModalContainer
                {...props}
                handleShowModal={handleShowModal}
                showModal={showModal}
                modalType="appraisal"
            />
        </React.Fragment>
    );
};

export default CreateCompModal;
